import _ from 'lodash';
    

    function GridService(model) {
        var self = this;
        self.model = model;

        if (_.isNil(self.model)) {
            throw new Error('Model is undefined at GridService!');
        }
    }

    GridService.prototype = {
        getDataset: function () {
            var self = this;
            return self.model.getDataset();
        },

        getDatasetMetadata: function () {
            var self = this;
            return self.model.getDatasetMetadata();
        },

        getHeaders: function () {
            var self = this;
            return self.model.getHeaders();
        },

        getPagination: function () {
            var self = this;
            return self.model.getPagination();
        },

        getSorting: function () {
            var self = this;
            return self.model.getSorting();
        },

        getSortingForApi: function () {
            var self = this;
            return self.model.getSortingForApi();
        },

        setDataset: function (dataset) {
            var self = this;
            self.model.setDataset(dataset);
        },

        setDatasetMetadata: function (dataset) {
            var self = this;
            self.model.setDatasetMetadata(dataset);
        },

        setHeaders: function (headers, needsSave) {
            var self = this;
            self.model.setHeaders(headers, needsSave);
        },

        setDefaultSort: function() {
            var self = this;
            self.model.setDefaultSort();
        },

        setHiddenHeaders: function (headers, needsSave) {
            var self = this;
            self.model.setHiddenHeaders(headers, needsSave);
        },

        getHiddenHeaders: function () {
            var self = this;
            return self.model.getHiddenHeaders();
        },

        setPagination: function (pagination, needsSave) {
            var self = this;
            self.model.setPagination(pagination, needsSave);
        },

        setPaginationPage: function (page, needsSave) {
            var self = this;
            var pagination = self.model.getPagination();
            _.set(pagination, 'page', page);
            self.model.setPagination(pagination, needsSave);
        },

        setPaginationSize: function (size, needsSave) {
            var self = this;
            var pagination = self.model.getPagination();
            _.set(pagination, 'size', size);
            self.model.setPagination(pagination, needsSave);
        },

        setSorting: function (sorting, needsSave) {
            var self = this;
            self.model.setSorting(sorting, needsSave);
        },

        fetchDataset: function () {
            var self = this;
            self.model.fetchDataset();
        },

        setupComplete: function () {
            var self = this;
            self.model.getInitialData();
        },


    };

    export default GridService;

